<picture aria-label="Logo for Melodi Grand Prix">
  <svg
    class="mgp-loader"
    width="150"
    height="136"
    viewBox="-4 -4 312 282"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      pathLength="100"
      id="mgp-loader__m"
      clip-rule="evenodd"
      d="M0 1.67637L151.024 88.8407L303.909 0.692261L304 193.545L277.536 208.828L277.437 46.4163L151.024 119.398L26.4553 47.4914L26.4635 209.936L0 194.654V1.67637Z"
    />
    <path
      pathLength="100"
      id="mgp-loader__g"
      clip-rule="evenodd"
      d="
                  M115.463 234.622V207.075L93.4903 194.389V168.893L137.792 194.48V274.218L48.7917 222.837V86.1694L137.792 137.55V165.337L71.1617 126.865L71.1203 209.018L115.463 234.622Z"
    />
    <path
      pathLength="100"
      id="mgp-loader__p"
      clip-rule="evenodd"
      d="
                  M164.265 137.525V274.201L186.593 261.357V216.237L255.233 176.616V85.0276L164.265 137.525Z"
    />
    <path
      pathLength="100"
      id="mgp-loader__innerp"
      clip-rule="evenodd"
      d="
                  M232.904 125.732V161.664L186.593 188.897L186.659 152.386L232.904 125.732Z"
    />
  </svg>
</picture>

<style>
  .mgp-loader {
    fill: none;
  }

  #mgp-loader__m,
  #mgp-loader__g,
  #mgp-loader__p,
  #mgp-loader__innerp {
    stroke-dasharray: 90 10;
    stroke: #ffeb9f;
    stroke-width: 0.35rem;
  }

  #mgp-loader__m {
    animation: drawdash 19s linear forwards infinite;
  }

  #mgp-loader__g {
    animation: drawdash 13s linear forwards infinite;
  }

  #mgp-loader__p {
    stroke-dasharray: 85 15;
    animation: drawdash 10s linear forwards infinite;
  }

  #mgp-loader__innerp {
    stroke-dasharray: 75 25;
    animation: drawdash 5s linear forwards infinite;
  }

  @keyframes drawdash {
    from {
      stroke-dashoffset: 100;
    }
    to {
      stroke-dashoffset: 0;
    }
  }
</style>
